export const NO_REFETCH_OPTIONS = {
  refetchInterval: false,
  refetchIntervalInBackground: false,
  // refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const
